import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import DateTimePicker from "@/components/calendar/DateTimePicker";
import CalendarConnectionStatus from "@/components/calendar/CalendarConnectionStatus";
import CalendarConnectionOptions from "@/components/calendar/CalendarConnectionOptions";
import { useCalendar } from "@/hooks/useCalendar";

type ScheduleFocusTimeProps = {
  buttonText?: string;
  duration?: number;
  className?: string;
  showIntegrationOption?: boolean;
  defaultTitle?: string;
  defaultDuration?: number;
};

const ScheduleFocusTime = ({
  buttonText = "Add to Calendar",
  duration = 60,
  className,
  showIntegrationOption = true,
  defaultTitle = "Focus Time",
  defaultDuration,
}: ScheduleFocusTimeProps) => {
  // Use defaultDuration if provided
  const effectiveDuration = defaultDuration || duration;

  const {
    date,
    setDate,
    time,
    setTime,
    hasCalendar,
    isLoading,
    isChecking,
    hasConflict,
    connectedProviders,
    connectionError,
    connectCalendar,
    scheduleFocusTime,
  } = useCalendar({
    defaultTitle,
    effectiveDuration,
  });

  return (
    <div className={cn("space-y-4", className)}>
      <DateTimePicker
        date={date}
        time={time}
        onDateChange={setDate}
        onTimeChange={setTime}
      />

      {hasCalendar && (
        <CalendarConnectionStatus
          hasCalendar={hasCalendar}
          isChecking={isChecking}
          hasConflict={hasConflict}
          connectedProviders={connectedProviders}
        />
      )}

      {!hasCalendar && showIntegrationOption && (
        <CalendarConnectionOptions
          connectionError={connectionError}
          isLoading={isLoading}
          onConnectCalendar={connectCalendar}
        />
      )}

      <Button
        onClick={scheduleFocusTime}
        disabled={isLoading || !date}
        className="w-full"
      >
        {isLoading ? "Scheduling..." : buttonText}
      </Button>
    </div>
  );
};

export default ScheduleFocusTime;
